import { z } from "zod";

const printerType = z.enum(["NETWORK", "USB"]);

const base = z.object({
  name: z.string().min(1, "Required"),
  type: printerType,
  address: z.string().nullish(),
  port: z.coerce.number().int().min(1).max(65535).nullish(),
  usbVendorId: z.string().nullish(),
  usbProductId: z.string().nullish(),
  label: z.string().nullish(),
  enabled: z.boolean().default(true),
});

function refineByType(data: z.infer<typeof base>, ctx: z.RefinementCtx) {
  if (data.type === "NETWORK" && !data.address) {
    ctx.addIssue({
      code: "custom",
      message: "Address is required for network printers",
      path: ["address"],
    });
  }
  if (data.type === "USB") {
    if (!data.usbVendorId) {
      ctx.addIssue({
        code: "custom",
        message: "Vendor ID is required for USB printers",
        path: ["usbVendorId"],
      });
    }
    if (!data.usbProductId) {
      ctx.addIssue({
        code: "custom",
        message: "Product ID is required for USB printers",
        path: ["usbProductId"],
      });
    }
  }
}

export const create = base.superRefine(refineByType);

export const update = base.extend({ id: z.number() }).superRefine(refineByType);

export type PrinterType = z.infer<typeof printerType>;
export type CreatePrinter = z.infer<typeof create>;
export type UpdatePrinter = z.infer<typeof update>;
